"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var UpdateConditionalOptions = /** @class */ (function (_super) {
    __extends(UpdateConditionalOptions, _super);
    function UpdateConditionalOptions() {
        var _this = _super.call(this, constants_1.DATA_UPDATE_CONDITIONAL_OPTIONS) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.updateConditionalOptions = document.querySelector("[".concat(constants_1.DATA_UPDATE_CONDITIONAL_OPTIONS, "]"));
        _this.conditionalOptions = document.querySelector("[".concat(constants_1.DATA_CONDITIONAL_OPTIONS, "]"));
        if (_this.updateConditionalOptions.selectedIndex !== 0) {
            _this.conditionalOptions.classList.remove('disabled');
            _this.conditionalOptions.disabled = false;
        }
        if (_this.conditionalOptions.classList.contains('filled')) {
            _this.conditionalOptions.closest('.form__group--product-select').classList.remove('disabled');
            _this.conditionalOptions.disabled = false;
        }
        if (_this.updateConditionalOptions[_this.updateConditionalOptions.selectedIndex].getAttribute('value')) {
            var selectedBrandId = _this.updateConditionalOptions[_this.updateConditionalOptions.selectedIndex].getAttribute('value');
            var conditionalOptionsJSON = _this.conditionalOptions.getAttribute('data-conditional-options');
            var items = JSON.parse(conditionalOptionsJSON);
            if (selectedBrandId) {
                _this.resetSelect(items);
                var optionFirst = document.createElement('option');
                optionFirst.innerText = ' ';
                optionFirst.value = '';
                _this.conditionalOptions.appendChild(optionFirst);
                _this.createOptions(selectedBrandId, items);
            }
            else {
                _this.resetSelect(items);
                _this.conditionalOptions.classList.add('disabled');
            }
        }
        _this.updateConditionalOptions.addEventListener('change', function () {
            var selectedBrandId = _this.updateConditionalOptions[_this.updateConditionalOptions.selectedIndex].getAttribute('value');
            var conditionalOptionsJSON = _this.conditionalOptions.getAttribute('data-conditional-options');
            var items = JSON.parse(conditionalOptionsJSON);
            if (selectedBrandId) {
                _this.resetSelect(items);
                var optionFirst = document.createElement('option');
                optionFirst.innerText = ' ';
                optionFirst.value = '';
                _this.conditionalOptions.appendChild(optionFirst);
                _this.createOptions(selectedBrandId, items);
            }
            else {
                _this.resetSelect(items);
                _this.conditionalOptions.classList.add('disabled');
            }
        });
        return _this;
    }
    UpdateConditionalOptions.prototype.createOptions = function (selectedBrand, items) {
        for (var i = 0; i < items.length; i++) {
            if (items[i].categoryId == selectedBrand) {
                var option = document.createElement('option');
                option.innerText = items[i].title;
                option.value = items[i].uid;
                this.conditionalOptions.classList.remove('disabled');
                this.conditionalOptions.classList.add('filled');
                this.conditionalOptions.closest('.form__group--product-select').classList.remove('disabled');
                this.conditionalOptions.closest('.form__group--product-select').classList.add('filled');
                this.conditionalOptions.appendChild(option);
            }
        }
        if (items.length > 1) {
            this.conditionalOptions.classList.remove('disabled');
            this.conditionalOptions.disabled = false;
        }
    };
    UpdateConditionalOptions.prototype.resetSelect = function (items) {
        this.conditionalOptions.classList.add('disabled');
        this.conditionalOptions.closest('.form__group--product-select').classList.add('disabled');
        this.conditionalOptions.disabled = true;
        this.conditionalOptions.options.length = 1;
        for (var i = items.length; i >= 0; i--) {
            this.conditionalOptions.options.remove(i);
            this.conditionalOptions.classList.remove('filled');
            this.conditionalOptions.closest('.form__group--product-select').classList.remove('filled');
        }
    };
    return UpdateConditionalOptions;
}(abstractComponent_1.default));
exports.default = UpdateConditionalOptions;
